module.exports = __webpack_public_path__ + "static/media/readCard.04376ebc.png";